export default __webpack_public_path__ + "static/media/leaderboard.7114edd6.svg";